export const frCommonInfos = {
    'commons.info.generalSectionTitle': 'Informations générales',

    'commons.info.label.title': 'Titre',
    'commons.info.label.name': 'Nom',
    'commons.info.label.ref': 'Réference',
    'commons.info.label.code': 'Code',
    'commons.info.label.description': 'Description',
    'commons.info.label.endDate': "Date d'échéance",
    'commons.info.endDate': "Sélectionnez une date d'échéance",
    'commons.info.description.placeholder': 'Saisissez ici la description',

    //* COMMON INFORMATION // OWNER
    'commons.info.owner.sectionTitle': 'Propriétaire',
    'commons.info.owner.floatingLabelTitle': 'Propriétaire',
    'commons.info.owner.listTitle': 'Choix du propriétaire',
    'commons.info.owner.listInputLabel': 'Chercher un utilisateur siège',

    //* COMMON INFORMATION // PDF
    'commons.info.docs.title': 'Joindre un fichier PDF',
    'commons.info.docs.label': 'Fichier PDF',
    'commons.info.docs.defaultDocumentName': 'Fichier PDF',
    'commons.info.docs.btn': 'Parcourir',

    //* COMMON INFORMATION // IMAGE
    'commons.info.addPhoto': 'Ajouter une photo',
    'commons.info.addPhotoLabel': 'Visuel photo',
    'commons.info.docs.imageUrl': "URL de l'image",
    'commons.info.docs.load': 'Charger',
    'commons.info.docs.hintHttp': 'http://...',
    'commons.info.addPhoto.or': 'OU',

    //* COMMON PUBLISH
    'commons.info.publishSectionTitle': 'Publication',
    'commons.info.select.publisher.sectionTitle': 'Publier en tant que',
    'commons.info.select.publisher.title': 'Sélectionnez le nom du publieur',
    'commons.info.select.publisher.floatingLabelTitle': 'Publier en tant que',
    'commons.info.select.publisher.listTitle': 'Choix du publieur',
    'commons.info.select.publisher.listInputLabel': 'Chercher un utilisateur ou une équipe',
    'commons.info.select.publisher.listCloseLabel': 'Fermer',

    'commons.info.publish.publishBtn': 'Publier',
    'commons.info.publish.cancelBtn': 'Annuler la publication',

    //* COMMON INFORMATIONS // AUTRE : video,
    'commons.info.select.catgory.label': 'Catégorie',
    'commons.info.select.catgory.hint': 'Sélectionnez une catégorie',

    'toast.apiErrors.ENTITY_ALREADY_PUBLISHED': 'Ce contenu est déjà publié',
};
